"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_table_1 = require("react-table");
const classes = __importStar(require("./Table.module.scss"));
require("./TableMobile.scss");
const url_1 = require("utils/url");
const hooks_1 = require("common/hooks");
const Pagination_1 = __importDefault(require("../Pagination"));
const Select_1 = __importDefault(require("../Select"));
const Loading_1 = require("../Loading");
const Table = react_1.default.memo(function Table({ columns, data, hasMore, fetching, onSetRange, refresher, styles = {
    borderRadius: "8px",
    borderColor: "#e5e7eb",
    headerBackground: "#f9fafb",
    stripedBackground: "#fafafa",
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
}, filterComponent, pageSize: initialPageSize = 20, topPagination = true, title, paginationWrapperStyle, }) {
    const { borderRadius, borderColor, headerBackground, boxShadow } = styles;
    const tableStyles = {
        borderRadius,
        border: `1px solid ${borderColor}`,
        overflow: "hidden",
        boxShadow,
    };
    const headerStyles = {
        backgroundColor: headerBackground,
        borderBottom: `1px solid ${borderColor}`,
        height: "32px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    };
    const cellStyles = {
        borderBottom: `1px solid ${borderColor}`,
        height: "20px",
        padding: "4px 16px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineHeight: "20px",
        fontSize: "14px",
        display: "table-cell",
        verticalAlign: "middle",
    };
    const searchParamAccessor = (0, url_1.useSearchParamAccessor)();
    const { value: paged, setValue: setPaged } = (0, hooks_1.useFieldAccessor)(searchParamAccessor, "paged");
    const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow, pageCount, state: { pageIndex, pageSize }, gotoPage, previousPage, nextPage, setPageSize, canPreviousPage, canNextPage, } = (0, react_table_1.useTable)({
        columns,
        data,
        autoResetPage: false,
        initialState: {
            pageSize: initialPageSize,
            pageIndex: paged || 0,
        },
    }, react_table_1.useSortBy, react_table_1.usePagination);
    const range = {
        min: pageIndex * pageSize,
        max: (pageIndex + 1) * pageSize - 1,
    };
    (0, react_1.useEffect)(() => {
        onSetRange === null || onSetRange === void 0 ? void 0 : onSetRange(range);
    }, [range.min, range.max]);
    (0, react_1.useEffect)(() => {
        gotoPage(paged || 0);
    }, [refresher]);
    (0, react_1.useEffect)(() => {
        setPaged(pageIndex || undefined);
    }, [pageIndex]);
    const { formatMessage } = (0, hooks_1.useFormatter)();
    return (react_1.default.createElement("div", { className: "table-wrapper", style: {
            display: "flex",
            flexFlow: "column",
            // padding: "8px",
            // paddingTop: "16px",
            gap: "16px",
        } },
        title && (react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "space-between",
                padding: "20px 20px 0 20px",
            } },
            react_1.default.createElement("p", { style: { fontWeight: 700 } }, title),
            react_1.default.createElement(Select_1.default, { value: pageSize, onChange: (e) => {
                    setPageSize(Number(e.target.value));
                }, options: [5, 10, 20, 30, 50, 100].map((value) => {
                    return {
                        value: value.toString(),
                        label: `${value} ${formatMessage("Table.perPage")}`,
                    };
                }) }))),
        topPagination && (react_1.default.createElement(Pagination_1.default, { pageSize,
            setPageSize,
            pageIndex,
            gotoPage,
            previousPage,
            nextPage,
            canPreviousPage,
            canNextPage,
            pageCount,
            data,
            range,
            hasMore,
            fetching, filterComponent: filterComponent })),
        react_1.default.createElement("div", { className: "table-main" },
            react_1.default.createElement("table", Object.assign({ className: "common-table table is-striped is-hoverable", style: Object.assign({ width: "100%", borderCollapse: "separate", borderSpacing: 0 }, tableStyles) }, getTableProps()),
                react_1.default.createElement("thead", null, headerGroups.map((headerGroup, headerGroupIndex) => (react_1.default.createElement("tr", Object.assign({}, headerGroup.getHeaderGroupProps(), { key: headerGroupIndex }), headerGroup.headers.map((column, index) => (react_1.default.createElement("th", Object.assign({ className: (0, classnames_1.default)({ [classes["isCurrentSort"]]: column.isSorted }, { [classes["isSortable"]]: column.canSort && !hasMore }), style: Object.assign(Object.assign({}, headerStyles), { fontWeight: 600, textAlign: "left", cursor: column.canSort ? "pointer" : "default" }) }, (hasMore
                    ? { key: index }
                    : column.getHeaderProps(column.getSortByToggleProps()))),
                    react_1.default.createElement("div", { style: { whiteSpace: "nowrap" } },
                        column.render("Header"),
                        column.isSorted && (react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: (0, classnames_1.default)("mdi", classes["tableIcon"], { "mdi-arrow-down": column.isSortedDesc }, { "mdi-arrow-up": !column.isSortedDesc }) }))))))))))),
                fetching ? (react_1.default.createElement("tbody", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement(Loading_1.Loading, null)))) : (react_1.default.createElement("tbody", Object.assign({}, getTableBodyProps()), page.map((row, rowIndex) => {
                    prepareRow(row);
                    return (react_1.default.createElement("tr", Object.assign({}, row.getRowProps(), { key: rowIndex }), row.cells.map((cell) => {
                        return (react_1.default.createElement("td", Object.assign({ "data-label": cell.column.Header, style: cellStyles }, cell.getCellProps()), cell.render("Cell")));
                    })));
                }))))),
        react_1.default.createElement("div", { style: paginationWrapperStyle },
            react_1.default.createElement(Pagination_1.default, { pageSize,
                pageIndex,
                gotoPage,
                previousPage,
                nextPage,
                canPreviousPage,
                canNextPage,
                pageCount,
                data,
                range,
                hasMore,
                fetching }))));
});
exports.default = Table;
